import { BasePdfGenerator } from "../../../../utils/pdf/BasePdfGenerator";
import {
  PDFLandscapeScheduleConstants,
  PDFPortraitScheduleConstants,
} from "../../../../utils/static/pdfConstants";

export const IRAS_TABLE_START_Y = 55;

const applyIrasLandscapeSettings = (pdf) => {
  if (!pdf || pdf.isExcel) return;

  pdf.isLandscape = true;
  pdf.constants = PDFLandscapeScheduleConstants;
  pdf.leftX = PDFLandscapeScheduleConstants.leftX;
  pdf.rightX = PDFLandscapeScheduleConstants.rightX;
  pdf.initY = PDFLandscapeScheduleConstants.initY;
  pdf.refreshY = PDFLandscapeScheduleConstants.initY;
  pdf.pageHeight = pdf.doc.internal.pageSize.height;
};

const applyIrasPortraitSettings = (pdf) => {
  if (!pdf || pdf.isExcel) return;

  pdf.isLandscape = false;
  pdf.constants = PDFPortraitScheduleConstants;
  pdf.leftX = PDFPortraitScheduleConstants.leftX;
  pdf.rightX = PDFPortraitScheduleConstants.rightX;
  pdf.initY = PDFPortraitScheduleConstants.initY;
  pdf.refreshY = PDFPortraitScheduleConstants.initY;
  pdf.pageHeight = pdf.doc.internal.pageSize.height;
};

export const createIrasPdfGenerator = (
  isExcel = false,
  isLandscape = false,
) => new BasePdfGenerator(isLandscape, isExcel);

export const addIrasLandscapePage = (pdf, startY = IRAS_TABLE_START_Y) => {
  if (pdf.isExcel) return;

  pdf.doc.addPage("a4", "landscape");
  applyIrasLandscapeSettings(pdf);
  pdf.startY = startY;
};

export const addIrasPortraitPage = (pdf, startY = IRAS_TABLE_START_Y) => {
  if (pdf.isExcel) return;

  pdf.doc.addPage("a4", "portrait");
  applyIrasPortraitSettings(pdf);
  pdf.startY = startY;
};

export const getIrasMainCompColumnStyles = (
  hasSgdColumn,
  hasReferenceColumn = false,
) => {
  if (hasSgdColumn) {
    return {
      0: { halign: "left", minCellWidth: hasReferenceColumn ? 52 : 72 },
      1: { halign: "right", valign: "bottom", cellWidth: 22 },
      2: { halign: "right", valign: "bottom", cellWidth: 22 },
      3: { halign: "right", valign: "bottom", cellWidth: 22 },
      4: { halign: "center", cellWidth: 16 },
      ...(hasReferenceColumn ? { 5: { halign: "center", cellWidth: 31 } } : {}),
    };
  }

  return {
    0: { halign: "left", minCellWidth: hasReferenceColumn ? 72 : 88 },
    1: { halign: "right", valign: "bottom", cellWidth: 28 },
    2: { halign: "right", valign: "bottom", cellWidth: 28 },
    3: { halign: "center", cellWidth: 16 },
    ...(hasReferenceColumn ? { 4: { halign: "center", cellWidth: 33 } } : {}),
  };
};

export const getIrasChargeableIncomeColumnStyles = (
  hasReferenceColumn = false,
) => ({
  0: { halign: "left", minCellWidth: hasReferenceColumn ? 72 : 88 },
  1: { halign: "right", valign: "bottom", cellWidth: 28 },
  2: { halign: "right", valign: "bottom", cellWidth: 28 },
  3: { halign: "center", cellWidth: 15 },
  ...(hasReferenceColumn ? { 4: { halign: "center", cellWidth: 34 } } : {}),
});
